import ServicesGrid from "@/components/ServicesGrid";
import SEO from "@/components/SEO";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function ServicesPage() {
  return (
    <>
      <SEO
        title="Services — MECA AUTO 17 Tonnay-Charente | Entretien, Diagnostic, Carrosserie"
        description="Découvrez les services de MECA AUTO 17 à Tonnay-Charente : entretien, vidange, freinage, pneumatiques, diagnostic, climatisation, carrosserie, contrôle technique. Devis gratuit."
      />
      <section className="pt-32 pb-16 px-6 md:px-12 bg-[#0D2C54] text-white">
        <div className="max-w-[1400px] mx-auto">
          <span className="overline text-[#E63946]">Nos prestations</span>
          <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight max-w-3xl">
            L'intégralité des services pour votre véhicule.
          </h1>
          <p className="mt-6 text-white/80 max-w-2xl text-lg">
            Entretien, mécanique, électronique, carrosserie : toutes nos prestations sont assurées par des techniciens certifiés, avec garantie pièces et main d'œuvre.
          </p>
          <div className="mt-8 flex gap-4">
            <Link to="/rendez-vous"><Button data-testid="services-rdv-btn" className="bg-[#E63946] hover:bg-[#D62839] rounded-none h-12 px-6 font-semibold">Prendre rendez-vous</Button></Link>
            <Link to="/devis"><Button data-testid="services-devis-btn" variant="outline" className="bg-transparent border-white/40 text-white hover:bg-white hover:text-[#0D2C54] rounded-none h-12 px-6 font-semibold">Devis gratuit</Button></Link>
          </div>
        </div>
      </section>
      <ServicesGrid />
    </>
  );
}
